import { PageId } from 'constants/pages'

export const enum PageIdStylioCapmoms {
  AGE_CAPMOMS = PageId.AGE_CAPMOMS,
  URGE_CAPMOMS = PageId.URGE_CAPMOMS,
  HAIR_COLOR_CAPMOMS = PageId.HAIR_COLOR_CAPMOMS,
  EYES_COLOR_CAPMOMS = PageId.EYES_COLOR_CAPMOMS,
  JEWELRY_CAPMOMS = PageId.JEWELRY_CAPMOMS,
  BODY_SHAPE_CAPMOMS = PageId.BODY_SHAPE_CAPMOMS,
  STYLIO_TO_HELP_CAPMOMS = PageId.STYLIO_TO_HELP_CAPMOMS,
  TALL_CAPMOMS = PageId.TALL_CAPMOMS,
  WEIGHT_CAPMOMS = PageId.WEIGHT_CAPMOMS,
  URGE_2_CAPMOMS = PageId.URGE_2_CAPMOMS,
  SHOPPING_CAPMOMS = PageId.SHOPPING_CAPMOMS,
  STYLE_MOST_MATTERS_CAPMOMS = PageId.STYLE_MOST_MATTERS_CAPMOMS,
  FEEL_ABOUT_CAPMOMS = PageId.FEEL_ABOUT_CAPMOMS,
  PERCENTAGE_CAPMOMS = PageId.PERCENTAGE_CAPMOMS,
  FAVORITE_COLORS_CAPMOMS = PageId.FAVORITE_COLORS_CAPMOMS,
  LIKE_OR_DISLIKE_CAPMOMS = PageId.LIKE_OR_DISLIKE_CAPMOMS,
  LIKE_OR_DISLIKE_11_CAPMOMS = PageId.LIKE_OR_DISLIKE_11_CAPMOMS,
  LIKE_OR_DISLIKE_12_CAPMOMS = PageId.LIKE_OR_DISLIKE_12_CAPMOMS,
  LIKE_OR_DISLIKE_13_CAPMOMS = PageId.LIKE_OR_DISLIKE_13_CAPMOMS,
  LIKE_OR_DISLIKE_14_CAPMOMS = PageId.LIKE_OR_DISLIKE_14_CAPMOMS,
  LIKE_OR_DISLIKE_15_CAPMOMS = PageId.LIKE_OR_DISLIKE_15_CAPMOMS,
  LIKE_OR_DISLIKE_16_CAPMOMS = PageId.LIKE_OR_DISLIKE_16_CAPMOMS,
  LIKE_OR_DISLIKE_17_CAPMOMS = PageId.LIKE_OR_DISLIKE_17_CAPMOMS,
  LIKE_OR_DISLIKE_18_CAPMOMS = PageId.LIKE_OR_DISLIKE_18_CAPMOMS,
  LIKE_OR_DISLIKE_19_CAPMOMS = PageId.LIKE_OR_DISLIKE_19_CAPMOMS,
  STYLES_FEEL_LIKE_YOU_CAPMOMS = PageId.STYLES_FEEL_LIKE_YOU_CAPMOMS,
  URGE_4_CAPMOMS = PageId.URGE_4_CAPMOMS,
  TIME_CAPMOMS = PageId.TIME_CAPMOMS,
  TYPICAL_DAY_CAPMOMS = PageId.TYPICAL_DAY_CAPMOMS,
  YOUR_LOCATION_CAPMOMS = PageId.YOUR_LOCATION_CAPMOMS,
  BRAND_CAPMOMS = PageId.BRAND_CAPMOMS,
  FIND_NEW_CLOTHES_CAPMOMS = PageId.FIND_NEW_CLOTHES_CAPMOMS,
  NOTHING_TO_WEAR_CAPMOMS = PageId.NOTHING_TO_WEAR_CAPMOMS,
  OLD_CLOTHES_CAPMOMS = PageId.OLD_CLOTHES_CAPMOMS,
  COMBINE_CLOTHES_CAPMOMS = PageId.COMBINE_CLOTHES_CAPMOMS,
  OPTIMIZE_BUDGET_CAPMOMS = PageId.OPTIMIZE_BUDGET_CAPMOMS,
  URGE_3_CAPMOMS = PageId.URGE_3_CAPMOMS,
  PREPARE_FLOW_CAPMOMS = PageId.PREPARE_FLOW_CAPMOMS,
  EMAIL_CAPMOMS = PageId.EMAIL_CAPMOMS,
  EMAIL_CONSENT_CAPMOMS = PageId.EMAIL_CONSENT_CAPMOMS,
  PRE_PAYWALL_OFFER_CAPMOMS = PageId.PRE_PAYWALL_OFFER_CAPMOMS,
  SUBSCRIPTIONS_CAPMOMS = PageId.SUBSCRIPTIONS_CAPMOMS,
  CANCEL_OFFER_CAPMOMS = PageId.CANCEL_OFFER_CAPMOMS,
  SUB_UPSELL_CAPMOMS = PageId.SUB_UPSELL_CAPMOMS,
  UPSELL_CAPMOMS = PageId.UPSELL_CAPMOMS,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPMOMS = PageId.DOWNLOAD_CAPMOMS,
}
